'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalFooter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalFooter = exports.GlobalFooter = (_temp = _class = function (_React$PureComponent) {
  _inherits(GlobalFooter, _React$PureComponent);

  function GlobalFooter() {
    _classCallCheck(this, GlobalFooter);

    return _possibleConstructorReturn(this, (GlobalFooter.__proto__ || Object.getPrototypeOf(GlobalFooter)).apply(this, arguments));
  }

  _createClass(GlobalFooter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          links = _props.links,
          copyright = _props.copyright;


      return _react2.default.createElement(
        'div',
        { className: 'j-com-globalFooter ' + className, style: style },
        links && _react2.default.createElement(
          'div',
          { className: 'links' },
          links.map(function (link) {
            var linkProps = link.action ? {
              onClick: function onClick(e) {
                return link.action(e, link);
              }
            } : {
              target: link.blankTarget ? '_blank' : '_self',
              href: link.href
            };
            return _react2.default.createElement(
              'a',
              _extends({ key: link.name || link.title }, linkProps),
              link.title
            );
          })
        ),
        copyright && _react2.default.createElement(
          'div',
          { className: 'copyright' },
          copyright
        )
      );
    }
  }]);

  return GlobalFooter;
}(_react2.default.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,

  links: _propTypes2.default.array,
  copyright: _propTypes2.default.string
}, _class.defaultProps = {
  className: ''
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/components/globalFooter/index.jsx
// module id = 13
// module chunks = 0